var _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "283.465px",
    height: "283.465px",
    viewBox: "0 0 283.465 283.465",
    enableBackground: "new 0 0 283.465 283.465",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "path",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    d: "M261.59,194.156l-49.975-13.957 c-0.958-0.27-1.931-0.475-2.916-0.606c-0.384-0.052-0.819-0.104-1.295-0.152c-6.298-0.637-12.558,1.53-17.188,5.85l-15.338,14.319 c-0.266,0.253-0.536,0.51-0.789,0.775c-1.199,1.251-7.367,6.818-16.868,0.206c-0.284-0.197-0.567-0.392-0.855-0.58 c-4.25-2.724-42.172-27.775-74.219-74.616c0,0-5.23-7.845,0.654-13.804c0,0,13.791-14.576,16.485-17.405 c0.213-0.226,0.432-0.444,0.654-0.663c1.16-1.138,6.569-7.275,3.57-20.29L90.443,23.86c-0.788-2.978-2.166-5.767-4.105-8.151 c-2.515-3.095-6.513-6.568-12.245-7.589c-0.327-0.057-0.658-0.113-0.985-0.187C70.571,7.392,57.795,4.82,48.423,5.984 c-2.432,0.301-4.781,1.055-6.97,2.153C32.696,12.536,6.74,28.65,6.378,65.243c0,0,0.218,24.41,7.628,46.422 c0,0,11.551,36.396,35.743,64.729c0,0,36.266,47.463,84.17,76.036c0,0,27.199,15.713,57.494,23.019c0,0,27.229,6.429,48.923-2.071 c0,0,27.378-9.45,36.916-33.262c0.92-2.293,1.417-4.733,1.495-7.201c0.14-4.228-0.235-11.695-2.99-22.522 C275.756,210.393,272.161,196.99,261.59,194.156z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    points: "1477.5,2817.919 1007.369,2378.114 537.233,1938.304 1007.369,1498.488 1477.502,1058.686  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "path",
    fill: "#231F20",
    d: "M1477.461,3006.886c-46.258,0-92.609-16.875-129.055-50.971L408.139,2076.3 c-38.194-35.732-59.872-85.693-59.872-137.996c0-52.302,21.677-102.265,59.871-137.995l470.135-439.816l470.136-439.804 c76.213-71.296,195.795-67.31,267.092,8.904c71.295,76.213,67.309,195.793-8.904,267.089l-792.758,741.62l792.756,741.621 c76.215,71.297,80.199,190.877,8.902,267.09C1578.295,2986.78,1527.935,3006.886,1477.461,3006.886z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    points: "3505.696,2817.919 3975.829,2378.114 4445.964,1938.304 3975.829,1498.488 3505.696,1058.686  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "path",
    fill: "#231F20",
    d: "M3505.733,3006.886c-50.477,0-100.828-20.1-138.035-59.873c-71.295-76.213-67.311-195.793,8.904-267.09 l792.756-741.621l-322.625-301.818l-470.131-439.802c-76.215-71.296-80.199-190.876-8.904-267.09 c71.301-76.213,190.881-80.199,267.092-8.902l470.131,439.803l470.137,439.816c38.197,35.73,59.873,85.693,59.873,137.995 c0,52.303-21.678,102.264-59.873,137.996l-940.268,879.615C3598.349,2990.007,3551.987,3006.886,3505.733,3006.886z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "path",
    fill: "#231F20",
    d: "M2070.881,3316.009c-21.896,0-44.15-3.832-65.875-11.914c-97.811-36.396-147.6-145.191-111.203-243.004 l824.58-2216.059c36.393-97.811,145.186-147.601,243-111.205c97.813,36.395,147.603,145.19,111.208,243.002l-824.583,2216.058 C2219.697,3268.976,2147.562,3316.009,2070.881,3316.009z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.65379f2d2e8e0b57d66b37a1011416cd.svg";
export { ForwardRef as ReactComponent };